import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatBlueprintManageEntityListFocus = createCustomElementWrapper('kat-blueprint-manage-entity-list-focus', 'KatBlueprintManageEntityListFocus', {}, {});



//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/katal-react/es/blueprint-manage-entity-list-focus.js
// module id = 1184
// module chunks = 0